export enum BranchAnalyticsEnum {
  VIEW_BRANCHES_PAGE = '[PAC WEB] Unidades Físicas - Página visualizada',
}
